import React from 'react';

const HeaderSmart = () => {
  return (
    <div style={{
      backgroundColor: '#000',
      padding: '1rem 2rem',
      color: '#faf9ea',
      fontWeight: 'bold',
      fontSize: '1.5rem',
      display: 'flex',
      alignItems: 'center',
      boxShadow: '0 4px 0 #000'
    }}>
      Dashboard
    </div>
  );
};

export default HeaderSmart;